import React, { PureComponent } from 'react'
import { connect } from 'react-redux'

import { hasPaintShop, hasBodyShop, hasCombinedBodyPaintShop, hasSubscriptionPermission } from '../../../utils/auth'
import { translation } from '../../../utils/helpers'

class DropdownBox extends PureComponent {

  constructor (props) {
    super(props)
    this.state = {
    }
    this.handle = this.handle.bind(this)
  }

  componentDidMount () {
    document.addEventListener('click', this.handle, true)
  }

  componentWillUnmount () {
    document.removeEventListener('click', this.handle, true)
  }

  handle (e) {
    const el = this.refs.dropdown_container
    if (!el.contains(e.target) && this.props.openDropdownLeft) {
      this.props.closeDropdown()
    }
  }

  render () {
    const toggleDropdownLeft = () => {
      console.log('toggle dropdown', !this.props.openDropdownLeft)
      this.props.toggleDropdown(!this.props.openDropdownLeft)
    }
    const isActive = (view) => {
      if (view === this.props.screenview) return 'active'
      return ''
    }
    let hasPaintShopValue = hasPaintShop(this.props.auth)
    let hasBodyShopValue = hasBodyShop(this.props.auth)
    let hasCombinedBodyPaintShopValue = hasCombinedBodyPaintShop(this.props.auth)
    let fullPaintScreenText = '1157'
    let fullBodyScreenText = '18' // '1157'
    let shopScreenText = '18'
    let prepScreenText = '19'
    let bodyWorkScreenText = '14826' // '18'
    if (hasCombinedBodyPaintShopValue === true) {
      fullPaintScreenText = '14822'
      fullBodyScreenText = '14821'
      shopScreenText = '14824'
      prepScreenText = '14825'
      bodyWorkScreenText = '14823'
    }
    const renderActiveName = () => {
      // console.log(this.props.screenview)
      switch (this.props.screenview) {
        case '0':
          return fullPaintScreenText
        case '1':
          return '1157'
        case '2':
          return fullBodyScreenText
        case '3':
          return shopScreenText
        case '4':
          return prepScreenText
        case '5':
          return '254'
        case '6':
          return bodyWorkScreenText
        case '7':
          return '1857'
        default:
          return '1157'
      }
    }
    return (
      <div className='dropdown__changeScreen' ref='dropdown_container'>
        <div onClick={toggleDropdownLeft} className='trigger'><label>{translation(renderActiveName())}</label> <i className='fa fa-chevron-down' /></div>
        {this.props.openDropdownLeft && (
          <div className='dropdown__box'>
            <div>
              {hasCombinedBodyPaintShopValue === true && (<a onClick={this.props.changeScreen.bind(this, '1')} className={isActive('1')}>{translation('1157')}</a>)}
              {hasBodyShopValue === true && (<a onClick={this.props.changeScreen.bind(this, '2')} className={isActive('2')}>{translation(fullBodyScreenText)}</a>)}
              {hasBodyShopValue === true && (<a onClick={this.props.changeScreen.bind(this, '6')} className={isActive('6')}>{translation(bodyWorkScreenText)}</a>)}
              {hasPaintShopValue === true && (<a onClick={this.props.changeScreen.bind(this, '0')} className={isActive('0')}>{translation(fullPaintScreenText)}</a>)}
              {hasPaintShopValue === true && (<a onClick={this.props.changeScreen.bind(this, '3')} className={isActive('3')}>{translation(shopScreenText)}</a>)}
              {hasPaintShopValue === true && (<a onClick={this.props.changeScreen.bind(this, '4')} className={isActive('4')}>{translation(prepScreenText)}</a>)}
              <a onClick={this.props.changeScreen.bind(this, '5')} className={isActive('5')}>{translation('254')}</a>
              {hasSubscriptionPermission(this.props.auth, 20) && this.props.auth.myscreen.Active && (<a onClick={this.props.changeScreen.bind(this, '7')} className={isActive('7')}>{translation('1857')}</a>)}
            </div>
          </div>
        )}
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {

})(DropdownBox)



// WEBPACK FOOTER //
// ./src/app/pages/NewWorkscreen/DropdownBox/index.js